import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUserState, IUser } from "../interfaces";

const initialState: IUserState = {
  authenticated: false,
  user:{
    id: '',
    name: '',
    email: '',
    role: '',
    profile: null,
    doctor: null,
  }
};

const userInfoSlice = createSlice({
  name: "route",
  initialState,
  reducers: {
    authUser: (state, action: PayloadAction<boolean>) => {
      state.authenticated = action.payload;
    },
    setUserInfo: (state, action: PayloadAction<IUser>) => {
      state.user = action.payload;
    },
  },
});

export const { authUser, setUserInfo } = userInfoSlice.actions;

export default userInfoSlice.reducer;
